import {
  createActions,
  ReplicantAsyncActionAPI,
  ReplicantSyncActionAPI,
} from '@play-co/replicant';
import { ReplicantFromState, stateSchema } from 'src/replicant/State';
import computedProperties from 'src/replicant/config/computedProperties';
import messages from 'src/replicant/config/messages';
import scheduledActions from 'src/replicant/config/scheduledActions';
import ab from 'src/replicant/ruleset/ab';
import asyncGetters from 'src/replicant/config/asyncGetters';

type Replicant = ReplicantFromState<typeof config>;
export type SyncActionAPI = ReplicantSyncActionAPI<Replicant>;
export type AsyncActionAPI = ReplicantAsyncActionAPI<Replicant>;
export type AnalyticsAPI = {
  sendAnalyticsEvents: SyncActionAPI['sendAnalyticsEvents'];
};

const config = {
  computedProperties,
  messages,
  scheduledActions,
  ruleset: { abTests: ab.dynamicAB },
  asyncGetters,
};
export default createActions(stateSchema, config);
